import $ from 'jquery';
import Form from 'root/module/form';
import _ from 'underscore';
import View from 'view/base';
import View_Project_Domains_Manage from 'view/project/domains_manage';
import View_Project_Page_Conditions from 'view/project/page_conditions';
import Cache from 'root/cache';
import Modals from 'root/modals';

export default View.extend({
    views: {
        domains: {}
    },

    events: {
        'change input[name="has_segment"]'              : 'onChangeSegment',
        'click li.user-segment'                         : 'onSegmentSelect',
        'click .segment-create'                         : 'onSegmentCreate',
        'click .segment-tag span'                       : 'onSegmentView',
        'click .segment-delete'                         : 'onSegmentDelete',
        'change input[name="has_page_condition"]'       : 'onChangePages',
        'change input[name="device_type"]'              : 'updateSettings',
        'click .account-upgrade'                        : 'onAccountUpgrade'
    },

    dom_handlers: {
        updateSettings: function() {
            this.updateSettings();
        },
        onSegmentSelect: function(e) {
            if (!Cache.account.hasFeature('segment_targeting')) {
                Modals.unlockFeature();
            }

            $(e.currentTarget).toggleClass('selected');
            var segment_id = $(e.currentTarget).data('val');

            var segments = [];
            if (this.model.get('user_segment')) {
                segments = this.model.get('user_segment').split(',').map(Number);
            }

            // check is on or off
            var is_selected = $(e.currentTarget).hasClass('selected');

            if (is_selected) {
                // add segment to user_segment
                segments.push(segment_id);
                segments = [...new Set(segments)];
            } else {
                // remove segment from user_segment
                segments = segments.filter((item) => item !== segment_id);
            }

            // filter invalid segments
            segments = segments.filter((item) => item !== '0' && item);

            this.model.set('user_segment', segments.join(','));
            this.renderSegmentSelector();
        },
        onSegmentCreate: function(e) {
            Modals.createUserSegment();
        },
        onSegmentDelete: function(e) {
            var segment_id = $(e.currentTarget).parents('.segment-tag').data('val');

            // remove segment from user_segment
            var segments = this.model.get('user_segment').split(',').map(Number);
            segments = segments.filter((item) => item !== segment_id && item !== '0' && item);

            this.model.set('user_segment', segments.join(','));
            this.renderSegmentSelector();
        },
        onSegmentView: function(e) {
            var segment_id = $(e.currentTarget).parents('.segment-tag').data('val');

            Modals.viewUserSegment(segment_id);
        },
        onChangeSegment: function(e) {
            var value = $(e.currentTarget).val();

            this.$el.find('.segments-selector').toggleClass('active', value === '1');

            this.updateSettings();
        },
        onChangePages: function(e) {
            var form_data = Form.getData(this.$el);

            this.$el.find('.region-page-conditions').toggleClass('active', form_data.has_page_condition === 1);

            this.updateSettings();
        },
        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        }
    },

    event_handlers: {
        onSegmentAdd: function(model) {
            // set user segment with new segment id
            var segments = this.model.get('user_segment').split(',').map(Number);
            segments.push(model.id);
            segments = segments.filter((item) => item !== '0' && item);
            this.model.set('user_segment', segments.join(','));

            this.renderSegmentSelector();
        },

        onDomainChange: function() {
            this.trigger('Domain:Change');
        },

        onPageConditionChange: function() {
            this.model.set('page_condition', this.views.page_conditions.getData());
        }
    },

    initialize: function() {
        this.views.domains = new View_Project_Domains_Manage({
            model: Cache.getDefaultProject(),
            show_save: false
        });

        this.views.page_conditions = new View_Project_Page_Conditions({
            data: this.model.get('page_condition'),
        });

        this.listenTo(Cache.user_segment, 'add',    this.event_handlers.onSegmentAdd.bind(this));
        this.listenTo(Cache.user_segment, 'change:name', this.renderSegmentSelector); // segment name change
        this.listenTo(this.views.domains, 'change', this.event_handlers.onDomainChange);
        this.listenTo(this.views.page_conditions, 'change', this.event_handlers.onPageConditionChange);
    },

    getSettings: function() {
        var form_data = Form.getData(this.$el);

        var settings_data = {
            has_segment        : form_data.has_segment === 1,
            device_type        : form_data.device_type.join(','),
            has_page_condition : form_data.has_page_condition === 1
        };

        return settings_data;
    },

    getDomains: function() {
        return this.views.domains.getData();
    },

    updateSettings: function() {
        var settings = this.getSettings();
        this.model.set(settings);
    },

    renderSegmentSelector: function() {
        var segments = this.model.get('user_segment') ? this.model.get('user_segment').split(',').map(Number) : [];
        var segment_content = '';

        var selected_segments_content = '';
        var all_segements_content = '';

        segments.forEach((segment_id) => {
            var segment = Cache.user_segment.get(segment_id);

            if (segment) {
                selected_segments_content +=
                '<span class="' + (segment.get('is_archived') ? 'badge-warning-invert' : 'badge-primary-invert') + ' badge-btn font-weight-medium segment-tag" data-val="' + segment_id + '">' +
                    '<span>' +
                        (segment.get('is_archived') ?
                        '<span class="tooltip" data-title="Segment is deactivated"><i class="fa-solid fa-triangle-exclamation"></i></span> ' : '') +
                        segment.get('segment_name') +
                    '</span>' +
                    '<button type="button" class="segment-delete"><i class="far fa-times"></i></button>' +
                '</span>';
            } else {
                selected_segments_content +=
                '<span class="badge-warning-invert badge-btn font-weight-medium segment-tag" data-val="' + segment_id + '">' +
                    '<span>Deleted segment</span>' +
                    '<button type="button" class="segment-delete"><i class="far fa-times"></i></button>' +
                '</span>';
            }
        });

        Cache.user_segment.where({is_archived: false}).forEach((segment) => {
            all_segements_content +=
            '<li data-val="' + segment.id + '" class="user-segment' + (segments.indexOf(segment.id) !== -1 ? ' selected' : '') + '">' + segment.escape('segment_name') + '</li>';
        });

        var is_segment_empty = segments.filter((item) => item !== '0' && item).length === 0;

        segment_content +=
        '<div>' +
            selected_segments_content +
            '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                '<button type="button" class="tertiary segment-button small">' +
                    (!is_segment_empty ? 'Add' : 'Select Segment') +
                '</button>' +
                '<div>' +
                    (all_segements_content ?
                    '<ul class="dropdown dropdown-select last-child">' + all_segements_content + '</ul>' :
                    '<ul class="dropdown"><li class="disabled">No segments found</li></ul>') +
                    '<div>' +
                        '<button type="button" class="segment-create text-link text-align-left full small"><i class="fa-solid fa-plus margin-right-4"></i>New Segment</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.find('.segments-selector').html(segment_content);
    },

    render: function() {
        var has_page_condition = this.model.get('has_page_condition');

        var content =
        '<div class="setting-title">Domains</div>' +
        '<div class="setting-subtitle">Add domains for where the survey will be triggered</div>' +
        '<div class="divider-12"></div>' +
        '<div class="region-domains"></div>' +
        '<hr class="medium">' +

        (Cache.account.hasFeature('survey_trigger') ? '' :
        '<button type="button" class="account-upgrade float-right tiny shiny"><span>UPGRADE</span></button>') +

        '<div class="setting-title">Segments</div>' +
        '<div class="setting-subtitle">Select who sees the form</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input id="segment_unused" type="radio" name="has_segment" value="0">' +
            '<label for="segment_unused">Anyone</label>' +
        '</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input id="segment_used" type="radio" name="has_segment" value="1">' +
            '<label for="segment_used">Users from segments</label>' +

            (Cache.account.hasFeature('segment_targeting') ? '' :
            '<button type="button" class="account-upgrade shiny tiny margin-left-4"><span>UPGRADE</span></button>') +

            '<div class="segments-selector"></div>' +
        '</div>' +

        '<hr class="medium">' +

        '<div class="setting-title">Pages</div>' +
        '<div class="setting-subtitle">Select where the form is displayed</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input id="condition_unused" type="radio" name="has_page_condition" value="0">' +
            '<label for="condition_unused">All pages</label>' +
        '</div>' +

        '<div class="divider-12"></div>' +

        '<div>' +
            '<input id="condition_used" type="radio" name="has_page_condition" value="1">' +
            '<label for="condition_used">Specific pages</label>' +
            '<div class="region-page-conditions"></div>' +
        '</div>' +

        '<hr class="medium">' +

        '<div class="setting-title">Devices</div>' +
        '<div class="setting-subtitle">Select devices for the form to display (select at least one)</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input type="checkbox" name="device_type" id="device_type_1" value="desktop">' +
            '<label for="device_type_1">Desktop</label>' +
            '<input type="checkbox" name="device_type" id="device_type_2" value="tablet">' +
            '<label for="device_type_2">Tablet</label>' +
            '<input type="checkbox" name="device_type" id="device_type_3" value="mobile">' +
            '<label for="device_type_3">Mobile</label>' +
        '</div>';

        this.$el.html(content);

        this.views.domains.render().$el.appendTo(this.$el.find('.region-domains'));
        this.views.page_conditions.render().$el.appendTo(this.$el.find('.region-page-conditions'));

        Form.setData(this.$el, {
            has_segment            : this.model.get('has_segment') ? '1' : '0',
            has_page_condition     : has_page_condition ? '1' : '0',
            device_type            : this.model.get('device_type') ? this.model.get('device_type').split(',') : []
        });

        this.$el.find('.region-page-conditions').toggleClass('active', has_page_condition);
        this.$el.find('.segments-selector').toggleClass('active', this.model.get('has_segment'));

        if (!Cache.account.hasFeature('segment_targeting')) {
            this.$el.find('.segment-button').prop('disabled', true);
        }

        if (!Cache.account.hasFeature('survey_trigger')) {
            this.$el.find('input[type="radio"]').prop('disabled', true);
            this.$el.find('input[type="checkbox"]').prop('disabled', true);
            this.$el.find('input[type="number"]').prop('disabled', true);
        }

        var segments = this.model.get('user_segment').split(',').map(Number);
        this.renderSegmentSelector(segments);

        return this;
    }
});
